import React, { useEffect, useState, useRef } from "react";

const AudioVisualizer = () => {
  const [audioData, setAudioData] = useState([]);
  const audioElementRef = useRef(null);

  useEffect(() => {
    // Verifica se o elemento de áudio já está presente
    const audioElement = document.getElementById("audio_remote");
    if (!audioElement) {
      console.error("Elemento audio_remote não encontrado.");
      return;
    }

    // Inicializa o volume e o estado do áudio
    const updateAudioData = () => {
      const volume = Math.round(audioElement.volume * 100);
      const isPlaying = !audioElement.paused;

      // Atualiza o estado com o volume e o estado de reprodução
      setAudioData([
        {
          id: "audio_remote",
          volume: volume, // Volume em %
          playing: isPlaying, // Se está tocando ou pausado
        },
      ]);
    };

    // Configura o evento de volume e o evento de play/pause
    audioElement.onvolumechange = updateAudioData;
    audioElement.onplay = updateAudioData;
    audioElement.onpause = updateAudioData;

    // Inicializa os dados com base no estado atual
    updateAudioData();

    // Cleanup: Não há necessidade de "desvincular" eventos, pois o elemento de áudio já está fixo
    return () => {
      audioElement.onvolumechange = null;
      audioElement.onplay = null;
      audioElement.onpause = null;
    };
  }, []); // Hook para rodar apenas uma vez quando o componente é montado

  return (
    <div>
      <div>
        <strong>Informações do Áudio:</strong>
        <ul>
          {audioData.length === 0 ? (
            <li>Sem áudio sendo reproduzido</li>
          ) : (
            <>
              <li>Volume: {audioData[0].volume}%</li>
              <li>
                Status: {audioData[0].playing ? "Reproduzindo" : "Pausado"}
              </li>
            </>
          )}
        </ul>
      </div>

      {/* Este é o elemento de áudio da chamada que o Mizu-VoIP está manipulando */}
      <audio id="audio_remote" autoPlay="autoplay"></audio>
    </div>
  );
};

export default AudioVisualizer;
